import _ from "underscore";
import { getAccessToken } from "../actions/Okta";
import * as awsConstants from "./../components/constants/fileConstants";




export function getCurrentDateTime() {
  const now = new Date();
  const options = {
    day: '2-digit',
    month: 'short',  // Use 'short' for abbreviated month names (e.g., Aug)
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,   // Use 12-hour clock (AM/PM)
  };
  const formatter = new Intl.DateTimeFormat('en-US', options);
  return formatter.format(now);

}

export function formatBytes(bytes, decimals) {
  if (bytes === 0) return "0 Bytes";
  var k = 1024,
    dm = decimals <= 0 ? 0 : decimals || 2,
    sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

// export function formatDate(dateString) {
//   console.log(dateString);
//   const dateObj = new Date(dateString);
//   return `${dateObj.toLocaleDateString()} ${dateObj.toLocaleTimeString()}`;
// }
// use a separate perser if date formats change in the future
function parseDateString(dateString) {

  // Attempt 1: Parse as YYYYMMDD format
  let dateObj = new Date(dateString?.slice(0, 4), dateString?.slice(4, 6) - 1, dateString?.slice(6));
  if (!isNaN(dateObj.getTime())) { // Check if valid date 
    return dateObj;
  }

  // Attempt 2: Parse using a more flexible format
  let formats = ["YYYY-MM-DDTHH:mm:ssZ", "YYYYMMDD", "YYYY-MM-DD"];
  for (let format of formats) {
    dateObj = new Date(dateString, format);
    if (!isNaN(dateObj.getTime())) {
      return dateObj;
    }
  }

  // If parsing fails, indicate an error
  throw new Error("Invalid date string format");
}
// A function to convert YYYYMMDDTHH:MM:SSZ format to YYYY-MM-DDTHH:MM:SSZ
function correctDateFormat(dateStr) {
  // Insert dashes for the date portion
  const correctedDate = dateStr.replace(
    /^(\d{4})(\d{2})(\d{2}T)/,
    '$1-$2-$3'
  );
  return correctedDate;
}




export function formatDate(dateString) {
  // const dateOptions = { year: "numeric", month: "short", day: "2-digit" };
  // const timeOptions = { hour: 'numeric', minute: '2-digit', hour12: true };
  const options = {
    day: '2-digit',
    month: 'short',  // Use 'short' for abbreviated month names (e.g., Aug)
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,   // Use 12-hour clock (AM/PM)
  };
  let dateObj;
  if ((dateString === null)) {
    return;
  }

  if (dateString.includes('Z')) {
    // Simple check for ISO 8601 - the API returns without dashes - so correct and format the date
    const correctedDate = correctDateFormat(dateString);
    dateObj = new Date(correctedDate);

  } else if (dateString.length === 8) { // Check for YYYYMMDD format
    const year = dateString.slice(0, 4);
    const month = dateString.slice(4, 6) - 1; // Adjust for zero-indexed months
    const day = dateString.slice(6);
    dateObj = new Date(year, month, day);
  } else {
    dateObj = new Date(dateString);

  }
  //dateObj = new Date(dateString);
  const dateFormatter = new Intl.DateTimeFormat('en-US', options);

  try {
    return dateObj ? dateFormatter.format(dateObj) : "";
  } catch (e) {
    console.log(e);
  }
  // if (timeOptions) {
  //   const timeFormatter = new Intl.DateTimeFormat('en-US', timeOptions);
  //   try {
  //     formattedTime = timeFormatter.format(dateObj);
  //   } catch (e) {
  //     console.log(e);
  //   }
  //   return `${formattedDate} ${formattedTime}`;
  // } else {
  //   return formattedDate;
  // }
}



export function guidDBG() {
  //const unixMilli = moment().valueOf();
  const unixMilli = Date.now();
  return `DBG-${unixMilli}`;
}

export function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return (
    s4() +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    s4() +
    s4()
  );
}

export function uploadSpeed(endTime, startTime, fileSize, bitsLoaded) {
  var duration = (endTime - startTime) / 1000;
  var speedBps = (bitsLoaded / duration).toFixed(2);
  var speedKbps = (speedBps / 1024).toFixed(2);
  //var speedMbps = (speedKbps / 1024).toFixed(2);
  return parseInt(speedKbps / 1000, 10);
}

export function transferTimeLeft(fileSize, transferSpeed, startTime) {
  var timeSeconds = (fileSize * 1024) / (transferSpeed / 8);
  timeSeconds = parseFloat(Math.round(timeSeconds * 100) / 100, 10);
  return timeSeconds;
}

export function setHeaders() {
  const accessToken = getAccessToken();
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json"
  };
  return headers;
}

export const parsePath = (url) => {
  return url.split("/")[1] || "home";
}

export const toTitleCase = (str) => {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export const parsePageTitle = (url) => {
  let output = "";
  const urlArray = _.compact(url.split("/"));
  urlArray.map(slice => {
    var temp = toTitleCase(slice);
    return (output = output + `${temp} `);
  });
  if (!output) {
    return "Home";
  }
  return output;
}

export default class {
  static hasProp(state, search) {
    var foundIt = _.has(state, search);
    return foundIt;
  }
}

export const validateDdpcrFileTypes = (fileType) => {

  const validFileExtensions = fileType.map((item) => {

    awsConstants.ENDPOINTS.validDdpcrFileTypes.includes(item)
    return "." + item;
  });
  return validFileExtensions;

}

export const validateQlpFileTypes = (fileType) => {

  const validFileExtensions = fileType.map((item) => {

    awsConstants.ENDPOINTS.validQlpFileTypes.includes(item)
    return "." + item;
  });
  return validFileExtensions;

}



export const isObjectEmptyNull = (value) => typeof value === "object" && value !== null && Object.values(value).every(x => (x === null || x === ''));


/**
 * Extracts a human-readable message from an axios error.
 * Handles two backend response shapes:
 *   replicate_analysis:             response.data.data         (JSON string)
 *   control_vs_experiment_analysis: response.data.data.body    (JSON string)
 * Both JSON strings carry an "error" key with the Python exception message.
 *
 * TODO: standardise API error responses across all backend endpoints so the
 * frontend can rely on a single shape (e.g. response.data.error) rather than
 * having to unwrap nested / inconsistently structured payloads here.
 */
export const parseApiError = (error) => {
    try {
        const raw = error?.response?.data?.data;
        const jsonStr = typeof raw === 'string' ? raw : raw?.body;
        if (jsonStr) {
            const parsed = JSON.parse(jsonStr);
            if (parsed?.error) {
                return `Metric ${parsed.error} is not available for this plate's data — it may need to be reprocessed.`;
            }
        }
    } catch { /* fall through */ }
    return error?.response?.data?.meta?.error || error?.message || 'An unexpected error occurred';
};

export const formatValue = (value) => {
  // Check if the value is a number
  if (typeof value === 'number') {
    // If it's a whole number, return it as-is
    if (Number.isInteger(value)) {
      return value;
    }
    // If it's a decimal, format to four decimal places
    return value.toFixed(4);
  }
  // Check if value is a string and ends with '%'
  else if (typeof value === 'string' && value.endsWith('%')) {

    const number = parseFloat(value);
    // If it's a valid number, format to four decimal places
    if (!isNaN(number)) {
      return `${number.toFixed(4)}%`;
    }
  }
  else if (typeof value === 'string') {
    return value;
  };
  // Return "N/A" for undefined or non-numeric values
  return "N/A";
}


// Function to get CSS class based on the channel
export const cssClassForChannel = (channel) => {
  switch (channel) {
    case 'FAM': return 'bg-[rgb(237,248,255)]';
    case 'VIC': return 'bg-[rgb(255,248,200)]';
    case 'HEX': return 'bg-[rgb(255,248,238)]';
    default: return '';
  }
};


export const cssClassForPlateData = (channel) => {
  switch (channel) {
    case 'FAM': return 'text-[rgb(2,119,189)]';
    case 'VIC': return 'text-[rgb(255,193,7)]';
    case 'HEX': return 'text-[rgb(255,152,0)]';
    default: return '';
  }
}


